module.exports = __webpack_public_path__ + "img/3.c3855b0e.svg";